import React from 'react'
import Script from 'next/script'

export default function Wisepops() {
  if (!process.env.WISEPOPS_ID) return null
  return (
    <>
      <Script
        id="wisepops-init"
        strategy="lazyOnload"
        dangerouslySetInnerHTML={{
          __html: `
            window.WisePopsObject = 'wisepops';
            window['wisepops'] = window['wisepops'] || function() {
              (window['wisepops'].q = window['wisepops'].q || []).push(arguments)
            };
            window['wisepops'].l = 1 * new Date();
          `
        }}
      />
      <Script
        id="wisepops-loader"
        src={`//loader.wisepops.com/get-loader.js?v=1&site=${process.env.WISEPOPS_ID}`}
        strategy="lazyOnload"
      />
    </>
  )
}
